<!-- components/NoticePopupApply.svelte -->
<script>
  import { onMount, onDestroy } from 'svelte';
  import { modifyNotice, registerNotice } from '@lib/api/notice';
  export let mode = 'create';       // 'create' = 등록, 'modify' = 수정
  export let onClose = () => {};    // 팝업 닫기 콜백
  export let onSave = () => {};     // 저장 완료 콜백

  export let initialData = {        // 수정 시 전달받는 초기 데이터
    noticeId:'',
    title:'',
    content:''
  };    

  let warningMessage = '';          // 공통 경고 메시지
  
  let formData = {
    title: '',
    content: '',
  };

  $: actionLabel = mode === 'create' ? '저장하기' : '수정하기';

  // 저장 처리 함수
  async function handleSubmit() {
    
    // 유효성 검사 시작
    if (!formData.title.trim()) {
      warningMessage = '공지 제목을 입력해주세요.';
      return;
    }

    if (!formData.content.trim()) {
      warningMessage = '공지 내용을 입력해주세요.';
      return;
    }

    // 유효성 통과 시
    warningMessage = ''; // 경고 초기화
    try {
      if (mode === 'create') {
        const result = await registerNotice(formData);
        console.log('등록 성공:', result);
      } else if (mode === 'modify') {
        const result = await modifyNotice(formData);
        console.log('수정 성공:', result);
      }

      onSave();
    }
     catch (e) {
      console.error('저장 실패:', e);
      warningMessage = e.message || '저장 중 오류가 발생했습니다.';
    }
  }
  
  onMount(() => {
    
    if (mode === 'modify' && initialData) {
        formData = {
          noticeId: initialData._id || '',
          title: initialData.title || '',
          content: initialData.content || '',
        };
      }
  });

  onDestroy(() => {
  });
</script>

<div class="popup-wrap">
  <div class="popup-overlay" role="presentation" aria-label="팝업 닫기" on:click={onClose}></div>
  <section class="popup-container">
    <div class="popup-container__inner d-flex" style="max-width:60.4rem;">
      <div class="d-flex flex-column w-100">
        <div class="popup-header">
          <div class="d-flex align-center w-100">
            <p class="font-20 font-weight-700 line-height-2">공지사항 등록하기</p>
            <button type="button" class="btn-close ml-auto" aria-label="닫기" on:click={onClose}>
              <i class="icon icon-close"></i>
            </button>
          </div>
        </div>
        <div class="popup-cont">
          <div class="d-flex h-100">
            <div class="prompt-block">
              <div class="table-wrap flex-1">
                <table class="table-basic table-border table-basic-inquiryAnswer">
                  <colgroup><col style="width:20%"><col style="width:auto"></colgroup>
                  <tbody>
                    <tr>
                      <th scope="row">공지제목</th>
                      <td>
                          <form action="" class="d-flex align-center flex-wrap gap-8">
                              <fieldset class="w-100">
                                  <legend>공지사항 등록 input 텍스트</legend>
                                  <label for="input-field-noticeApply">
                                      <input type="text" name="" id="input-field-noticeApply" class="input-field height-40" title="공지사항 등록 input 텍스트" placeholder=""  bind:value={formData.title}>
                                  </label>
                              </fieldset>
                          </form>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                          <div class="custom-textarea h-100">
                              <form action="" class="h-100">
                                  <fieldset class="h-100">
                                      <legend></legend>
                                      <textarea class="h-100" placeholder="지문 내용을 입력" title="지문 내용을 입력" style="min-height:48.5rem" bind:value={formData.content}></textarea>
                                  </fieldset>
                              </form>
                          </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {#if warningMessage}
              <p class="d-flex align-center mt-3 font-13 color-red">
                <i class="icon icon-calmMark-red mr-1"></i>
                {warningMessage}
              </p>
              {/if}
            </div>
          </div>
        </div>
        <div class="popup-footer">
          <div class="btn-wrap justify-center" style="border-top:none;">
            <button type="button" class="btn border-blue" on:click={onClose}>취소</button>
            <button type="button" class="btn bg-blue ml-2" on:click={handleSubmit}>{actionLabel}</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>